import { action, observable, makeObservable } from 'mobx';

interface IExtensionAggregation {
    id: string;
    name: string;
    count: number;
}

export default class ExtensionAggregationStore {
    extensionAggregation: IExtensionAggregation = {
        id: '',
        name: '',
        count: 0
    };

    constructor(extensionAggregation: IExtensionAggregation) {
        makeObservable(this, {
            extensionAggregation: observable,
            update: action
        });

        this.update(extensionAggregation);
    }

    update(extensionAggregation: IExtensionAggregation): void {
        this.extensionAggregation = {
            ...this.extensionAggregation,
            ...extensionAggregation
        };
    }
}
